import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const Hero = () => {
  const { FiArrowRight, FiTrendingUp } = FiIcons;

  return (
    <section className="relative min-h-[95vh] flex items-center pt-20 overflow-hidden bg-slate-950">
      <div className="absolute inset-0 z-0 overflow-hidden">
        <video autoPlay muted loop playsInline className="w-full h-full object-cover transition-opacity duration-1000 opacity-100 scale-100">
          <source src="https://s3.us-east-2.wasabisys.com/crc-cdn/crc/CRCNU-Hero.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-slate-950 via-slate-950/40 to-transparent"></div>
        <div className="absolute inset-y-0 left-0 w-full lg:w-1/2 bg-gradient-to-r from-slate-950/40 to-transparent pointer-events-none"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div initial={{ opacity: 0, x: -50 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }}>
            <div className="inline-flex items-center space-x-2 bg-blue-600/40 border border-blue-400/50 backdrop-blur-md rounded-full px-4 py-2 mb-6">
              <span className="flex h-2 w-2 rounded-full bg-blue-400 animate-pulse"></span>
              <span className="text-xs font-bold text-white uppercase tracking-wider">#1 NYC SEO & GEO Agency</span>
            </div>
            <h1 className="text-5xl md:text-7xl font-extrabold text-white leading-[1.1] mb-6 tracking-tight drop-shadow-[0_4px_12px_rgba(0,0,0,0.9)]">
              NYC SEO That Puts Your Business <span className="gradient-text">Above the Competition</span>
            </h1>
            <p className="text-lg md:text-xl text-white mb-8 max-w-2xl leading-relaxed font-bold drop-shadow-[0_2px_8px_rgba(0,0,0,1)]">
              Dominate traditional Google search results and emerging AI-powered engines like ChatGPT and Gemini. We turn New York City search traffic into verifiable revenue.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <Link to="/contact" className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-md text-lg font-bold transition-all text-center flex items-center justify-center space-x-2 shadow-[0_0_30px_rgba(37,99,235,0.7)]">
                <span>Dominate NYC Search Now</span>
                <SafeIcon icon={FiArrowRight} />
              </Link>
              <Link to="/geo-ai-optimization" className="glass-panel bg-white/20 hover:bg-white/30 text-white px-8 py-4 rounded-md text-lg font-bold transition-all text-center backdrop-blur-xl border border-white/40 shadow-xl">
                Explore AI SEO (GEO)
              </Link>
            </div>
          </motion.div>

          <motion.div initial={{ opacity: 0, scale: 0.9, y: 20 }} animate={{ opacity: 1, scale: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }} className="relative hidden lg:block">
            <div className="glass-panel p-6 rounded-2xl border border-white/40 relative z-10 shadow-[0_25px_60px_rgba(0,0,0,0.7)] backdrop-blur-3xl bg-slate-900/30">
              <div className="flex items-center justify-between border-b border-white/20 pb-4 mb-4">
                <div className="flex space-x-2">
                  <div className="w-3 h-3 rounded-full bg-red-500 shadow-lg shadow-red-500/50"></div>
                  <div className="w-3 h-3 rounded-full bg-yellow-500 shadow-lg shadow-yellow-500/50"></div>
                  <div className="w-3 h-3 rounded-full bg-green-500 shadow-lg shadow-green-500/50"></div>
                </div>
                <div className="text-xs text-white font-mono tracking-widest uppercase font-black">Live Ranking Dashboard</div>
              </div>
              <div className="space-y-4">
                {[
                  { term: "SEO Agency NYC", engine: "Google", pos: "1", color: "text-blue-400" },
                  { term: "Best Law Firm Manhattan", engine: "ChatGPT", pos: "Top Entity", color: "text-purple-400" },
                  { term: "Local Traffic Growth", engine: "Local Map Pack", pos: "1", color: "text-green-400" }
                ].map((item, i) => (
                  <div key={i} className="bg-slate-950/95 rounded-lg p-4 flex justify-between items-center border border-white/20 hover:border-blue-500/50 transition-all group shadow-lg">
                    <div>
                      <div className="text-white font-black group-hover:text-blue-400 transition-colors">{item.term}</div>
                      <div className="text-[10px] text-slate-400 uppercase tracking-tighter mt-1 font-black">{item.engine}</div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <span className={`${item.color} font-mono text-lg font-black`}>#{item.pos}</span>
                      <SafeIcon icon={FiTrendingUp} className="text-green-500" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;